import Base from "./Base";
import axios from "./axios_c";
import Bom from "@system/config/bom";
import ResponseMaker from "./BOMProjectAPICall/responseMaker";
import liveAuth from "../helper/liveAuth";
import Helper from "src/support/Helper";

class BOMProjectAPICall extends Base {
    listProject = async (params = false) => {
        if (!liveAuth.check()) {
            return {};
        }
        let res = {};
        await this.axiosCall(Bom.LIST_PROJECT, params, 'GET').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    listProjectDetailWithBOM = async (params = false) => {
        if (!liveAuth.check()) {
            return new ResponseMaker({}).process().run().get();
        }
        let res = {};
        await this.axiosCall(Bom.LIST_PROJECT_DETAIL_WITH_BOM, params, 'GET').then((resHer) => {
            res = resHer.data.data;
        });
        return new ResponseMaker(res).process().run().get();
    };
    createProject = async (params = false) => {
        let res = {};
        if (params.bomId !== undefined && params.bomId === false) {
            delete params.bomId;
        }
        await this.axiosCall(Bom.CREATE_PROJECT, params, 'POST').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    editProject = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.EDIT_PROJECT, params, 'POST').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    // Not used anywhere
    fetchSingleProject = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.FETCH_SINGLE_PROJECT, params, 'GET').then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    deleteProject = async (params = false) => {
        let res = {};
        await this.axiosCall(Bom.DELETE_PROJECT, params, 'DELETE', true).then((resHer) => {
            res = resHer.data;
        });
        return res;
    };
    axiosCall = async (url, data = {}, method = 'post', skipData = false) => {
        let config = {
            method: method,
            url: url,
            headers: Helper.getCommonHeader(method)
        };

        if (!skipData) {
            config.data = data;
        }
        if (config.method !== 'post' && config.method !== 'POST') {
            config.params = data;
        }
        return axios(config);
    };
}

export default BOMProjectAPICall;